import React from 'react';
import mapValues from 'lodash/mapValues';
import { number, object, string } from 'yup';

import { castArray } from 'lodash';
import FormGroup from '~/commons/components/FormGroup.jsx';

import env from '~/commons/config/env';
import LangTabs from '../layout/LangTabs.jsx';
import FormResource from './FormResource.jsx';

const defaults = {
  version: 1,
  key: 'ua',
  model: '',
  orgId: 0,
  title: mapValues(env.langs, () => ''),
  content: mapValues(env.langs, () => ''),
};

const schema = object({
  key: string(),
  orgId: number().integer().min(1, 'Organization ID is required'),
});

const FormTerm = ({ term }) => (
  <FormResource
    {...{
      defaults,
      stored: term,
      schema,
      api: '/api/site/terms',
      onSubmit: (values) => ({
        ...values,
        ...(values.key === 'pp' ? { model: '' } : {}),
      }),
    }}>
    {({ values }) => (
      <>
        <FormGroup name="version" type="number" />
        {castArray(env.user?.roles).includes('admin') && (
          <div className="row">
            <div className="col">
              {' '}
              <FormGroup name="key" as="select">
                <option value=""> - </option>
                {[
                  { v: 'ua', l: 'Unassigned' },
                  { v: 'tc', l: 'Terms & Conditions' },
                  { v: 'pp', l: 'Privacy Policy' },
                  { v: 'dc', l: 'Disclaimer' },
                ].map(({ v, l }) => (
                  <option value={v} key={v}>
                    {l}
                  </option>
                ))}
              </FormGroup>
            </div>
            {['tc', 'dc'].includes(values.key) && (
              <div className="col">
                <FormGroup name="model" as="select">
                  <option value="">All</option>
                  {['Order', 'Consignment', 'Quotation'].map((v) => (
                    <option value={v} key={v}>
                      {v}
                    </option>
                  ))}
                </FormGroup>
              </div>
            )}
          </div>
        )}
        <FormGroup name="orgId" type="number" label="Organization ID" />

        <LangTabs>
          {({ lang }) => (
            <div className="pt-3">
              <FormGroup name={`title.${lang}`} label="Title" />
              <FormGroup
                name={`content.${lang}`}
                label="Content"
                as="summernote"
                fileUploadUrl="/api/site/terms/files"
              />
            </div>
          )}
        </LangTabs>
      </>
    )}
  </FormResource>
);

export default FormTerm;
